module.exports = __webpack_public_path__ + "static/media/rsmlink.106ee411.svg";